"use strict"; // !!
// Don't edit this file or you're fired!
// !!

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var v4_1 = __importDefault(require("uuid/v4"));

var config_1 = __importDefault(require("./config"));

var SchemaName;

(function (SchemaName) {
  SchemaName["Device"] = "Data-Device";
  SchemaName["Invoice"] = "Data-Invoice";
  SchemaName["Option"] = "Data-Option";
  SchemaName["Payment"] = "Data-Payment";
  SchemaName["Product"] = "Data-Product";
  SchemaName["Price"] = "Data-Price";
  SchemaName["Shop"] = "caves";
  SchemaName["StockActivity"] = "Data-StockActivity";
  SchemaName["Tax"] = "Data-Tax";
  SchemaName["Variant"] = "Data-Variant";
  SchemaName["VariantPrice"] = "Data-VariantPrice";
})(SchemaName || (SchemaName = {}));

function data(context, options) {
  var _a, _b;

  var _config_1$default = config_1.default(options),
      DATA_ENDPOINT = _config_1$default.DATA_ENDPOINT;

  var auth = context.auth;
  var shopId = auth.shop.id;
  var deviceId = (_b = (_a = auth) === null || _a === void 0 ? void 0 : _a.device) === null || _b === void 0 ? void 0 : _b.id;
  var node = {
    shopId: shopId,
    deviceId: deviceId
  };
  var headers = Object.assign({
    'Content-Type': 'application/json',
    'x-shop-id': shopId
  }, deviceId && {
    'x-device-id': deviceId
  });

  function decodeIds(encodedIds) {
    if (encodedIds) {
      if (Array.isArray(encodedIds.values)) {
        return encodedIds.values;
      }

      return encodedIds;
    } else {
      return [];
    }
  }

  function unmarshallItem(item, relations) {
    var results = Object.assign({}, item);

    for (var index = 0; index < relations.length; index++) {
      var key = relations[index];
      results[key] = decodeIds(results[key]);
    }

    return results;
  }

  function handleOverrides(body) {
    var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    if (Array.isArray(overrides) && overrides.length) {
      for (var index = 0; index < overrides.length; index++) {
        var override = overrides[index];
        delete body[override];
      }
    }

    return body;
  }

  function model(schemaName, relations, overrides) {
    function findById(id) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var url, response, results;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  url = "".concat(DATA_ENDPOINT, "/").concat(schemaName, "/").concat(id);
                  _context.next = 4;
                  return fetch(url, {
                    headers: headers
                  });

                case 4:
                  response = _context.sent;
                  _context.next = 7;
                  return response.json();

                case 7:
                  results = _context.sent;
                  resolve(unmarshallItem(results, relations));
                  _context.next = 14;
                  break;

                case 11:
                  _context.prev = 11;
                  _context.t0 = _context["catch"](0);
                  reject(_context.t0);

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 11]]);
        }));
      });
    }

    function create(item) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var url, id, checksum, body, response, results;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  url = "".concat(DATA_ENDPOINT, "/").concat(schemaName);
                  id = v4_1.default(); // @TOTO: use @data/checksum

                  checksum = '-';
                  body = JSON.stringify(handleOverrides(Object.assign(Object.assign(Object.assign({
                    id: id
                  }, item), node), {
                    checksum: checksum,
                    updatedAt: Date.now() / 1000,
                    createdAt: Date.now() / 1000
                  }), overrides));
                  _context2.next = 7;
                  return fetch(url, {
                    method: 'post',
                    headers: headers,
                    body: body
                  });

                case 7:
                  response = _context2.sent;
                  _context2.next = 10;
                  return response.json();

                case 10:
                  results = _context2.sent;
                  resolve(unmarshallItem(results, relations));
                  _context2.next = 17;
                  break;

                case 14:
                  _context2.prev = 14;
                  _context2.t0 = _context2["catch"](0);
                  reject(_context2.t0);

                case 17:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[0, 14]]);
        }));
      });
    }

    function update(id, item) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var url, checksum, body, response;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.prev = 0;
                  url = "".concat(DATA_ENDPOINT, "/").concat(schemaName, "/").concat(id); // @TOTO: use @data/checksum

                  checksum = '-';
                  body = JSON.stringify(handleOverrides(Object.assign(Object.assign(Object.assign({}, item), node), {
                    checksum: checksum,
                    updatedAt: Date.now() / 1000
                  }), overrides));
                  _context3.next = 6;
                  return fetch(url, {
                    method: 'put',
                    headers: headers,
                    body: body
                  });

                case 6:
                  response = _context3.sent;

                  if (response.ok) {
                    _context3.next = 9;
                    break;
                  }

                  throw Error('Something went wrong');

                case 9:
                  resolve(true);
                  _context3.next = 15;
                  break;

                case 12:
                  _context3.prev = 12;
                  _context3.t0 = _context3["catch"](0);
                  reject(_context3.t0);

                case 15:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[0, 12]]);
        }));
      });
    }

    function archive(id) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        return __awaiter(_this4, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var response;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.prev = 0;
                  _context4.next = 3;
                  return update(id, {
                    archivedAt: Date.now() / 1000
                  });

                case 3:
                  response = _context4.sent;
                  resolve(response);
                  _context4.next = 10;
                  break;

                case 7:
                  _context4.prev = 7;
                  _context4.t0 = _context4["catch"](0);
                  reject(_context4.t0);

                case 10:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, null, [[0, 7]]);
        }));
      });
    }

    return {
      findById: findById,
      create: create,
      update: update,
      archive: archive
    };
  } // LOL, typescript sucks


  var device = model(SchemaName.Device, []);
  var invoice = model(SchemaName.Invoice, ['payments_ids']);
  var option = model(SchemaName.Option, []);
  var payment = model(SchemaName.Payment, []);
  var price = model(SchemaName.Price, []);
  var product = model(SchemaName.Product, ['variants_ids', 'categories_ids', 'label_ids', 'tax_ids']);
  var shop = model(SchemaName.Shop, [], ['shopId', 'deviceId']);
  var stockActivity = model(SchemaName.StockActivity, []);
  var tax = model(SchemaName.Tax, []);
  var variant = model(SchemaName.Variant, ['product_ids', 'variantPrices_ids']);
  var variantPrice = model(SchemaName.VariantPrice, ['variant_ids', 'price_ids']); // Return models

  return {
    device: device,
    invoice: invoice,
    option: option,
    payment: payment,
    price: price,
    product: product,
    shop: shop,
    stockActivity: stockActivity,
    tax: tax,
    variant: variant,
    variantPrice: variantPrice
  };
}

exports.default = data;